export default {
  "nav": {
    "telecom": "الاتصالات",
    "telecomInfrastructures": "البنية التحتية",
    "telecomFibre": "الألياف البصرية",
    "telecomMaintenance": "الصيانة",
    "genieCivilBTP": "الهندسة المدنية والبناء",
    "home": "الرئيسية",
    "solutions": "الحلول",
    "projets": "المشاريع",
    "aPropos": "من نحن",
    "contact": "اتصل بنا",
    "getQuote": "طلب عرض سعر"
  },
  "footer": {
    "telecomList": {
      "towers": "أبراج الاتصالات",
      "fibre": "الألياف الضوئية",
      "maintenance": "صيانة NOC"
    },
    "tagline": "رائد في البنى التحتية للاتصالات وحلول الطاقة منذ عام 2006. نربط المجتمعات وندعم التنمية المستدامة.",
    "subscribe": "اشتراك",
    "subscribePlaceholder": "بريدك الإلكتروني",
    "services": "الخدمات",
    "servicesList": {
      "microgrids": "الشبكات الصغيرة",
      "solarPumping": "الضخ بالطاقة الشمسية",
      "storage": "التخزين",
      "evCharging": "شحن المركبات الكهربائية",
      "constructionMetal": "الإنشاءات المعدنية والهندسة المدنية",
      "itNetworks": "تقنية المعلومات والشبكات",
      "audit": "التدقيق والاستشارات",
      "telecom": "الاتصالات",
      "transport": "النقل والخدمات اللوجستية",
      "expertise": "الخبرة التقنية"
    },
    "company": "الشركة",
    "companyList": {
      "about": "من نحن",
      "projects": "مشاريعنا",
      "products": "المنتجات",
      "contact": "اتصل بنا"
    },
    "contact": "اتصل بنا",
    "copyright": "© 2026 IS TELECOM. جميع الحقوق محفوظة.",
    "terms": "الشروط والأحكام",
    "privacy": "سياسة الخصوصية",
    "ctaTitle1": "بنى تحتية",
    "ctaTitle2": "اتصالات وطاقة",
    "ctaTitle3": "لكل منطقة",
    "ctaButton": "طلب عرض سعر"
  },
  "hero": {
    "badge": "{ الطاقة والاتصالات }",
    "titleLine1": "حلول",
    "titleLine2": "طاقة واتصالات",
    "titleLine3": "للغد",
    "subtitle": "منذ عام 2006، تقوم IS TELECOM بنشر البنى التحتية للاتصالات وحلول الطاقة في 6 دول أفريقية.",
    "cta": "طلب عرض سعر"
  },
  "overview": {
    "badge": "حول IS TELECOM",
    "titleLine1": "التميز في",
    "titleLine2": "كل مشروع بنية تحتية",
    "description": "يجمع فريقنا متعدد التخصصات بين خبرة الاتصالات والطاقة لتقديم حلول بنية تحتية موثوقة. من أبراج الإرسال إلى الشبكات الشمسية الصغيرة، نربط المجتمعات وندعم التنمية المستدامة.",
    "learnMore": "معرفة المزيد",
    "statYears": "سنوات من الخبرة",
    "statCountries": "دولة مخدومة",
    "statProjects": "مشروع مكتمل"
  },
  "features": {
    "badge": "المميزات",
    "title": "ثلاث خبرات، مهمة واحدة: بناء أفريقيا الغد",
    "items": [
      {"title": "البنية التحتية للاتصالات"},
      {"title": "الهندسة المدنية والبناء"},
      {"title": "حلول الطاقة"}
    ]
  },
  "services": {
    "badge": "خدماتنا",
    "title": "حلول مصممة حسب احتياجاتك",
    "description": "من الطاقة الشمسية إلى الاتصالات والبناء والنقل، تغطي خبرتنا متعددة التخصصات جميع مشاريع البنية التحتية الخاصة بك.",
    "list": [
      {"title": "تقييم الطاقة الشمسية", "tags": ["طاقة شمسية", "استشارات"]},
      {"title": "تركيب الألواح", "tags": ["طاقة شمسية", "تركيب"]},
      {"title": "تخزين البطاريات", "tags": ["طاقة شمسية", "تخزين"]},
      {"title": "المراقبة والدعم", "tags": ["طاقة شمسية", "مراقبة"]},
      {"title": "الإنشاءات المعدنية والهندسة المدنية", "tags": ["هندسة مدنية", "إنشاءات"]},
      {"title": "تقنية المعلومات والشبكات", "tags": ["تقنية معلومات", "شبكات"]},
      {"title": "التدقيق والاستشارات", "tags": ["تدقيق", "استشارات"]},
      {"title": "الاتصالات", "tags": ["اتصالات", "بنية تحتية"]},
      {"title": "النقل والخدمات اللوجستية", "tags": ["لوجستيات", "نقل"]}
    ]
  },
  "projects": {
    "badge": "مشاريعنا",
    "title": "إنجازاتنا الحديثة",
    "viewDetails": "عرض التفاصيل",
    "list": [
      {
        "category": "شبكات صغيرة",
        "year": "2023",
        "title": "قرية — كهربة ريفية",
        "description": "نظام شمسي مصمم خصيصًا يقلل من تكاليف الطاقة ويجلب الطاقة النظيفة لمجتمعك."
      },
      {
        "category": "اتصالات",
        "year": "2025",
        "title": "مشغل — شبكة اتصالات وطنية",
        "description": "نشر البنية التحتية للاتصالات مع الطاقة الشمسية لـ 200 موقع، لضمان اتصال موثوق في المناطق الريفية والحضرية."
      },
      {
        "category": "مراقبة",
        "year": "2024",
        "title": "ذكي — مراقبة متقدمة",
        "description": "تتبع أداء نظامك من خلال تركيب شمسي متصل يساعدك على فهم كل كيلوواط يتم إنتاجه."
      }
    ]
  },
  "partners": {
    "badge": "شركاؤنا",
    "title": "يثقون بنا",
    "description": "يتعاون قادة عالميون في الاتصالات والطاقة والتكنولوجيا مع IS TELECOM لنشر حلول مستدامة في جميع أنحاء أفريقيا."
  },
  "process": {
    "badge": "العملية",
    "title": "من الدراسة إلى التشغيل",
    "description": "نرافقكم من التدقيق الأولي إلى التشغيل الكامل، سواء كان ذلك للبنية التحتية للاتصالات أو مشاريع الطاقة.",
    "stepPrefix": "الخطوة",
    "steps": [
      {"title": "الدراسة والهندسة", "description": "نحلل احتياجاتك وندرس التضاريس ونصمم خططًا هندسية مفصلة لمشروع البنية التحتية الخاص بك."},
      {"title": "البناء والتركيب", "description": "تقوم فرقنا المعتمدة بتنفيذ الهندسة المدنية وإقامة الهياكل وتركيب المعدات بدقة وأمان."},
      {"title": "الاختبار والتشغيل", "description": "نختبر بدقة كل مكون ونتحقق من الأداء ونضمن التشغيل الكامل لبنيتك التحتية."}
    ]
  },
  "testimonials": {
    "badge": "آراء العملاء",
    "titleLine1": "شركاء موثوقون،",
    "titleLine2": "بنية تحتية موثوقة",
    "verifiedReviews": "تقييم موثق",
    "items": [
      {"quote": "نشرت IS TELECOM أكثر من 200 موقع لشبكتنا في السنغال. فريقهم يتقن معدات Huawei بشكل كامل والتزم بجميع المواعيد النهائية، حتى في المناطق الأكثر صعوبة في الوصول.", "name": "أحمدو ديالو", "role": "مدير الشبكة، MTN السنغال"},
      {"quote": "جودة عملهم على شبكتنا الأساسية للألياف البصرية رائعة. اختبارات OTDR لا تشوبها شائبة، توثيق كامل، وفريق يعرف معايير Ericsson عن ظهر قلب.", "name": "Amina Diallo", "role": "مديرة البنية التحتية، Orange CI"},
      {"quote": "دعمهم عبر NOC على مدار الساعة يصنع الفارق كله. عندما يتعطل موقع في الثالثة صباحًا، يكون فريق IS TELECOM في الموقع عند الخامسة. مستوى استجابة لا تجده في أي مكان آخر.", "name": "Koffi Agbessi", "role": "المدير التقني، Moov Africa"},
      {"quote": "عهدنا إليهم بتحديث الجيل الرابع لـ 150 موقعًا. تدريب الفرق، التركيب، تحسين الراديو — تم تسليم كل شيء في الوقت المحدد بجودة تفوق توقعاتنا.", "name": "د. Fatou Beye", "role": "المديرة التقنية، Airtel Senegal"},
      {"quote": "IS TELECOM هو شريكنا المرجعي للصواري. هياكلهم قوية، مطابقة للمعايير الزلزالية، والهندسة المدنية لا تشوبها شائبة. عمل عالي الجودة حقًا.", "name": "Moussa Coulibaly", "role": "مدير النشر، Vodacom"},
      {"quote": "نشر FTTH سريع ونظيف. في 3 أشهر، قاموا بتمديد الكابلات في كامل منطقتنا الحضرية. إتقانهم لـ GPON وإدارة المشاريع مثير للإعجاب.", "name": "Sophie Lawson", "role": "المديرة التنفيذية، Togocom"}
    ]
  },
  "faq": {
    "badge": "الأسئلة الشائعة",
    "title": "الأسئلة المتكررة",
    "homeFaqs": [
      {"q": "01. ما هي خدمات الاتصالات التي تقدمها IS TELECOM؟", "a": "نقوم بنشر بنية تحتية كاملة للاتصالات: الأبراج والصواري، شبكات الألياف البصرية، صيانة معدات الراديو، وحلول الربط للمناطق الريفية والحضرية. كشركاء لـ Huawei وEricsson وMTN، نغطي سلسلة الاتصالات بأكملها."},
      {"q": "02. في أي دول تعملون؟", "a": "IS TELECOM موجودة في 6 بلدان أفريقية في غرب وشرق أفريقيا: بنين، توغو، مالي، زامبيا، تنزانيا والسنغال. لدينا مكاتب في كل من هذه البلدان وننفذ مشاريع اتصالات وطاقة هناك."},
      {"q": "03. ما أنواع أبراج الاتصالات التي تركبونها؟", "a": "نصمم ونركب جميع أنواع الصواري: ذاتية الدعم (حتى 120م)، مثبتة بالأسلاك، أحادية القطب الحضرية، والصواري الأنبوبية. كل تركيب يلتزم بالمعايير الدولية ANSI/TIA-222."},
      {"q": "04. هل تقدمون عقود صيانة للاتصالات؟", "a": "بالتأكيد. تشمل عقود الصيانة لدينا تدخلات وقائية مجدولة، دعم NOC على مدار الساعة، تدخلات تصحيحية في غضون 4 ساعات (SLA مضمون)، وإدارة كاملة لقطع الغيار."}
    ]
  },
  "contact": {
    "pageTitle": "اتصل بنا",
    "pageSubtitle": "هل أنت مستعد لنشر بنيتك التحتية للاتصالات أو مشروع الطاقة الخاص بك؟ فريقنا هنا لمساعدتك",
    "infoPhone": "الهاتف",
    "infoEmail": "البريد الإلكتروني",
    "infoAddress": "العنوان",
    "infoHours": "ساعات العمل",
    "hoursLine1": "الاثنين - الجمعة: 8:00 - 18:00",
    "hoursLine2": "دعم NOC: 24/7",
    "formTitle": "أرسل لنا رسالة",
    "formSubtitle": "املأ النموذج أدناه وسيرد عليك فريقنا في غضون 24 ساعة.",
    "formSuccess": "تم إرسال الرسالة!",
    "formSuccessMsg": "سنرد عليك في أقرب وقت ممكن.",
    "labelName": "الاسم الكامل",
    "placeholderName": "اسمك الكامل",
    "labelEmail": "البريد الإلكتروني",
    "placeholderEmail": "your@email.com",
    "labelPhone": "الهاتف",
    "placeholderPhone": "+229 XX XX XX XX",
    "labelSubject": "الموضوع",
    "subjectOptions": {
      "info": "معلومات عامة",
      "tech": "معلومات تقنية",
      "partnership": "شراكة",
      "careers": "وظائف",
      "other": "أخرى"
    },
    "labelMessage": "الرسالة",
    "placeholderMessage": "صف مشروعك أو أسئلتك...",
    "sending": "جارٍ الإرسال...",
    "send": "إرسال الرسالة",
    "quickResponse": "هل تحتاج إلى إجابة سريعة؟",
    "freeQuote": "عرض سعر مجاني:",
    "freeQuoteDesc": "احصل على تقدير في غضون 48 ساعة عمل لأي مشروع بنية تحتية.",
    "techSupport": "الدعم الفني:",
    "techSupportDesc": "مركز NOC متاح على مدار الساعة للعملاء بعقود صيانة.",
    "siteVisit": "زيارة ميدانية:",
    "siteVisitDesc": "نتنقل مجانًا لتقييم احتياجات البنية التحتية الخاصة بك.",
    "faqTitle": "الأسئلة الشائعة",
    "contactFaqs": [
      {"q": "كم من الوقت يستغرق نشر موقع اتصالات؟", "a": "بالنسبة لموقع قياسي، المدة هي 2 إلى 4 أسابيع بعد الدراسة الهندسية. بالنسبة لمشاريع الألياف الأساسية أو متعددة المواقع، يتم تخصيص الجدول الزمني حسب نطاق المشروع."},
      {"q": "هل تقدمون خدمات صيانة الاتصالات؟", "a": "نعم، جميع عقودنا تشمل صيانة وقائية مجدولة ودعم NOC على مدار الساعة مع تدخل مضمون في غضون 4 ساعات. نقدم أيضًا عقود صيانة موسعة."},
      {"q": "كم من الوقت للحصول على عرض سعر؟", "a": "نرسل لك عرض سعر مفصل في غضون 48 ساعة عمل بعد استلام طلبك. للمشاريع المعقدة، قد تكون الزيارة الفنية ضرورية."},
      {"q": "هل تعملون خارج أفريقيا؟", "a": "نشاطنا مركز على 6 بلدان أفريقية: بنين، توغو، مالي، زامبيا، تنزانيا والسنغال. هذا الوجود المستهدف يتيح لنا تقديم خبرة محلية واستجابة مثلى في كل من هذه الأسواق."},
      {"q": "ما هي الشهادات التي تمتلكونها؟", "a": "نحن معتمدون ISO 9001 وISO 14001. فرقنا مدربة ومعتمدة من Huawei وEricsson وNokia. جميع تركيباتنا تلتزم بمعايير ANSI/TIA-222."}
    ]
  },
  "devis": {
    "pageTitle": "اطلب عرض السعر المخصص لك",
    "pageSubtitle": "صف مشروع البنية التحتية للاتصالات أو الطاقة الخاص بك واحصل على تقدير مفصل في غضون 48 ساعة، بدون أي التزام",
    "badge": "عرض سعر مجاني",
    "advantages": [
      {"text": "رد خلال 48 ساعة"},
      {"text": "عرض سعر مجاني وبدون التزام"},
      {"text": "دراسة مخصصة من قبل خبرائنا"},
      {"text": "نعمل في 6 دول أفريقية"}
    ],
    "step1Title": "الخطوة 1: معلوماتك",
    "step2Title": "الخطوة 2: مشروعك",
    "step3Title": "الخطوة 3: الملخص",
    "labelName": "الاسم الكامل",
    "labelCompany": "الشركة / المؤسسة",
    "placeholderCompany": "اسم شركتك",
    "labelEmail": "البريد الإلكتروني",
    "labelPhone": "الهاتف",
    "labelLocation": "موقع المشروع",
    "placeholderLocation": "المدينة، الدولة",
    "labelProjectType": "نوع المشروع",
    "selectProject": "اختر نوع المشروع",
    "labelBudget": "الميزانية المقدرة",
    "selectBudget": "اختر نطاقًا",
    "labelTimeline": "الجدول الزمني المطلوب",
    "selectTimeline": "اختر جدولًا زمنيًا",
    "labelPower": "التفاصيل التقنية (اختياري)",
    "placeholderPower": "مثال: صارية 80م، شبكة أساسية 200كم، 50 موقع اتصالات...",
    "labelDescription": "وصف المشروع",
    "placeholderDescription": "صف مشروع البنية التحتية الخاص بك، أهدافك، القيود التقنية...",
    "continue": "متابعة",
    "back": "رجوع",
    "send": "إرسال الطلب",
    "sending": "جارٍ الإرسال...",
    "success": "تم طلب عرض السعر بنجاح!",
    "successMsg": "يقوم فريقنا بتحليل مشروعك وسيرد عليك في غضون 48 ساعة عمل باقتراح مفصل.",
    "recapName": "الاسم:",
    "recapCompany": "الشركة:",
    "recapEmail": "البريد الإلكتروني:",
    "recapPhone": "الهاتف:",
    "recapProjectType": "نوع المشروع:",
    "recapLocation": "الموقع:",
    "recapBudget": "الميزانية:",
    "recapTimeline": "الجدول الزمني:",
    "recapPower": "التفاصيل التقنية:",
    "recapDescription": "الوصف:",
    "projectTypes": [
      {"value": "micro-reseau", "label": "شبكة شمسية صغيرة"},
      {"value": "pompage", "label": "ضخ شمسي"},
      {"value": "stockage", "label": "تخزين الطاقة"},
      {"value": "recharge-ve", "label": "شحن المركبات الكهربائية"},
      {"value": "residentiel", "label": "تركيب سكني"},
      {"value": "industriel", "label": "تركيب صناعي"},
      {"value": "btp", "label": "الإنشاءات المعدنية والهندسة المدنية"},
      {"value": "informatique", "label": "تقنية المعلومات (شبكات، خوادم)"},
      {"value": "audit", "label": "التدقيق والاستشارات"},
      {"value": "telecom", "label": "اتصالات (أبراج، ألياف)"},
      {"value": "transport", "label": "النقل والخدمات اللوجستية"},
      {"value": "autre", "label": "مشروع آخر"}
    ],
    "budgets": [
      {"value": "", "label": "اختر نطاقًا"},
      {"value": "moins-5k", "label": "أقل من 5,000 يورو"},
      {"value": "5k-20k", "label": "5,000 - 20,000 يورو"},
      {"value": "20k-100k", "label": "20,000 - 100,000 يورو"},
      {"value": "100k-500k", "label": "100,000 - 500,000 يورو"},
      {"value": "plus-500k", "label": "أكثر من 500,000 يورو"}
    ],
    "timelines": [
      {"value": "", "label": "اختر جدولًا زمنيًا"},
      {"value": "urgent", "label": "عاجل (أقل من شهر)"},
      {"value": "1-3", "label": "1 إلى 3 أشهر"},
      {"value": "3-6", "label": "3 إلى 6 أشهر"},
      {"value": "6-12", "label": "6 إلى 12 شهرًا"},
      {"value": "plus-12", "label": "أكثر من 12 شهرًا"}
    ],
    "afterTitle": "ماذا يحدث بعد طلبك",
    "afterBadge": "ماذا بعد؟",
    "afterSteps": [
      {"title": "تأكيد", "desc": "تتلقى بريدًا إلكترونيًا للتأكيد مع ملخص طلبك في غضون ساعة واحدة."},
      {"title": "تحليل الخبراء", "desc": "يدرس فريقنا الفني مشروعك ويقيم الجدوى التقنية."},
      {"title": "عرض سعر مفصل", "desc": "تتلقى عرض سعر كامل مع المواصفات التقنية والجداول الزمنية والأسعار في غضون 48 ساعة."},
      {"title": "مناقشة مخصصة", "desc": "يتصل بك مدير المشروع لمناقشة عرض السعر والإجابة على أسئلتك."}
    ],
    "faqTitle": "أسئلة حول عروض الأسعار",
    "devisFaqs": [
      {"q": "هل عرض السعر مجاني حقًا؟", "a": "نعم، بالتأكيد. دراسة مشروعك وإعداد عرض السعر مجانيان تمامًا وبدون أي التزام من جانبك."},
      {"q": "متى سأتلقى عرض السعر الخاص بي؟", "a": "نلتزم بإرسال عرض سعر مفصل لك في غضون 48 ساعة عمل. للمشاريع المعقدة التي تتطلب زيارة ميدانية، قد يكون الموعد من 5 إلى 7 أيام."},
      {"q": "ماذا يتضمن عرض السعر؟", "a": "يتضمن عرض السعر: المواصفات التقنية المفصلة، قائمة كاملة بالمعدات، جدول التركيب، شروط الضمان، والسعر الإجمالي المفصل."},
      {"q": "هل يمكنني تعديل مشروعي بعد استلام عرض السعر؟", "a": "بالطبع! عرض السعر هو أساس للمناقشة. فرقنا متاحة لتعديل الحل وفقًا لاحتياجاتك وقيودك."}
    ]
  },
  "about": {
    "pageTitle": "حول IS TELECOM",
    "pageSubtitle": "قصة رائد الاتصالات في أفريقيا، في خدمة الربط منذ عام 2006",
    "missionBadge": "مهمتنا",
    "missionTitle": "ربط أفريقيا بشبكات الغد",
    "missionDesc1": "تأسست IS TELECOM في عام 2006 برؤية طموحة: بناء البنية التحتية للاتصالات التي تربط السكان الأفارقة ببقية العالم. من كوتونو، نسجنا شبكة من الثقة مع أكبر الفاعلين العالميين في قطاع الاتصالات.",
    "missionDesc2": "اليوم، كشركاء لـ Huawei وEricsson وMTN وOrange وغيرهم، قمنا بنشر أكثر من 5,000 موقع اتصالات في 6 دول أفريقية. تغطي خبرتنا السلسلة بأكملها: الأبراج والألياف البصرية والصيانة والطاقة الشمسية للمواقع المعزولة.",
    "statCountries": "دولة مخدومة",
    "statProjects": "مشروع مكتمل",
    "statExperts": "خبير منتشر",
    "statCapacity": "موقع اتصالات منشور",
    "certifiedBadge": "معتمد ISO 9001",
    "certifiedSub": "جودة مضمونة",
    "valuesBadge": "قيمنا",
    "valuesTitle": "ما يوجهنا يوميًا",
    "values": [
      {"title": "الربط الشامل", "desc": "نؤمن بأن كل مجتمع يستحق وصولاً موثوقاً إلى شبكات الاتصالات، من الحواضر الكبرى إلى القرى الأكثر عزلة."},
      {"title": "التميز التقني", "desc": "جميع مواقعنا تلتزم بأشد المعايير الدولية صرامة. فرقنا مدربة ومعتمدة من Huawei وEricsson وNokia."},
      {"title": "الانتشار الدولي", "desc": "متواجدون في 6 دول أفريقية في غرب وشرق أفريقيا، نكيف حلول الربط لدينا مع السياقات المحلية والاحتياجات الخاصة."},
      {"title": "الابتكار المستمر", "desc": "نستثمر في تقنيات الغد: الجيل الخامس، إنترنت الأشياء، الحوسبة الطرفية والمدن الذكية."},
      {"title": "القرب من العميل", "desc": "دعم شخصي مع دعم فني NOC على مدار الساعة، في كل أنحاء أفريقيا."},
      {"title": "الأثر الاجتماعي", "desc": "كل موقع اتصالات ننشره يخلق وظائف محلية ويفتح الوصول إلى التعليم والصحة والاقتصاد الرقمي."}
    ],
    "timelineBadge": "مسيرتنا",
    "timelineTitle": "19 عامًا من الريادة في الاتصالات",
    "timeline": [
      {"year": "2006", "title": "تأسيس IS TELECOM", "desc": "تأسست الشركة في كوتونو، بنين، بمهمة واضحة: نشر البنية التحتية للاتصالات التي ستربط غرب أفريقيا."},
      {"year": "2009", "title": "شراكة Huawei", "desc": "توقيع أول عقد شراكة مع Huawei Technologies لنشر البنية التحتية للراديو في غرب أفريقيا. تدريب أولى فرقنا المعتمدة."},
      {"year": "2012", "title": "شراكة Ericsson", "desc": "تصبح IS TELECOM شريكًا معتمدًا لـ Ericsson لصيانة ونشر معدات RAN (شبكة الوصول الراديوي). التوسع إلى توغو ومالي."},
      {"year": "2015", "title": "عقد إطار مع MTN", "desc": "توقيع عقد إطار متعدد السنوات مع MTN لنشر وصيانة أكثر من 800 موقع اتصالات في 6 دول أفريقية."},
      {"year": "2019", "title": "نشر الجيل الرابع والألياف", "desc": "إطلاق أولى عمليات نشر 4G/LTE وشبكات الألياف البصرية الأساسية. أكثر من 2,000 موقع اتصالات قيد الإدارة النشطة."},
      {"year": "2024", "title": "رائد عموم أفريقيا", "desc": "أكثر من 5,000 موقع اتصالات منشور في 6 دول أفريقية. شراكات استراتيجية مع Orange وAirtel وVodacom. شهادة ISO 9001 وتأهيل مسبق للجيل الخامس."}
    ],
    "certBadge": "الشهادات",
    "certTitle": "شهاداتنا",
    "certDesc": "معايير دولية لضمان جودة وسلامة بنيتنا التحتية للاتصالات",
    "certs": [
      {"label": "ISO 9001", "desc": "الجودة"},
      {"label": "Huawei Certified", "desc": "شريك معتمد"},
      {"label": "Ericsson Certified", "desc": "RAN & Core"},
      {"label": "ISO 14001", "desc": "البيئة"}
    ]
  },
  "solutions": {
    "pageTitle": "حلولنا وخدماتنا",
    "pageSubtitle": "بنية تحتية للاتصالات وأنظمة طاقة مخصصة لتلبية جميع احتياجاتك، من أبراج الإرسال إلى مشاريع الطاقة الشمسية الصناعية",
    "processBadge": "عمليتنا",
    "processTitle": "كيف نعمل",
    "processSteps": [
      {"title": "التدقيق والاستشارات", "desc": "تحليل احتياجاتك التقنية ودراسة الجدوى في الموقع، سواء للاتصالات أو الطاقة."},
      {"title": "التصميم", "desc": "تحجيم مخصص مع خطط هندسية مفصلة لبنيتك التحتية."},
      {"title": "التركيب", "desc": "التنفيذ من قبل فرقنا المعتمدة، مع الامتثال للمعايير الدولية."},
      {"title": "المراقبة والصيانة", "desc": "مراقبة عن بعد وتدخلات وقائية مضمونة على مدار الساعة."}
    ],
    "ctaTitle": "هل تحتاج إلى حل مخصص؟",
    "ctaSubtitle": "يدرس مهندسونا مشروعك في الاتصالات أو الطاقة مجانًا ويقترحون حلاً يتناسب مع احتياجاتك وميزانيتك.",
    "ctaButton": "طلب تدقيق مجاني",
    "keyFeatures": "الميزات الرئيسية",
    "useCases": "حالات الاستخدام",
    "requestQuote": "طلب عرض سعر لهذا الحل",
    "solutions": [
      {
        "title": "أنظمة الشبكات الصغيرة",
        "shortDesc": "حلول كاملة للكهربة الريفية والحضرية مع إدارة ذكية.",
        "fullDesc": "تم تصميم أنظمة الشبكات الصغيرة لدينا لتوفير طاقة موثوقة ومستدامة في المناطق غير المتصلة بالشبكة الوطنية. يدمج كل حل الألواح الكهروضوئية وبطاريات التخزين والمحولات الذكية ونظام مراقبة مركزي.",
        "features": ["إدارة آلية للإنتاج والاستهلاك", "مراقبة في الوقت الفعلي عبر منصة الويب والهاتف المحمول", "صيانة تنبؤية مع تنبيهات تلقائية", "تكامل سهل مع مصادر الطاقة الموجودة", "تسعير ذكي وإدارة المشتركين"],
        "useCases": ["القرى الريفية في أفريقيا", "المناطق شبه الحضرية", "الجزر المعزولة", "المواقع الصناعية النائية"]
      },
      {
        "title": "الضخ الشمسي",
        "shortDesc": "أنظمة ضخ وري شمسية للزراعة وإمدادات المياه.",
        "fullDesc": "تحول حلول الضخ الشمسي لدينا ضوء الشمس إلى مياه شرب وري. متكيفة مع السياقات الريفية والزراعية، تقلل من التكاليف التشغيلية وتضمن توفر المياه باستمرار.",
        "features": ["مضخات غاطسة عالية الكفاءة", "أنظمة ري بالتنقيط مدمجة", "تحكم تلقائي في التدفق والضغط", "متوافقة مع الآبار العميقة", "متانة متكيفة مع الظروف المناخية القاسية"],
        "useCases": ["العمليات الزراعية", "المجتمعات الريفية", "مزارع الماشية", "الحدائق النباتية"]
      },
      {
        "title": "تخزين الطاقة",
        "shortDesc": "حلول تخزين سكنية وصناعية مع بطاريات ليثيوم عالية الأداء.",
        "fullDesc": "التخزين هو قلب أي تركيب شمسي مستقل. نقدم حلول بطاريات ليثيوم أيون من الجيل التالي، بقدرات من السكني إلى الصناعي، مقترنة بمحولات هجينة ذكية.",
        "features": ["بطاريات ليثيوم عالية الكثافة الطاقوية", "محولات هجينة مع تبديل تلقائي", "إدارة ذكية لدورة الشحن/التفريغ", "قابلية توسع معيارية حسب الحاجة", "ضمان ممتد يصل إلى 15 عامًا"],
        "useCases": ["المنازل الفردية", "الفنادق والمنتجعات", "المراكز الصحية", "الصناعات"]
      },
      {
        "title": "شحن المركبات الكهربائية",
        "shortDesc": "محطات شحن شمسية للمركبات الكهربائية، حلول كاملة ومستدامة.",
        "fullDesc": "نقوم بتركيب محطات شحن للمركبات الكهربائية تعمل بالطاقة الشمسية بنسبة 100%. من الشواحن السكنية إلى محطات الشحن السريع العامة، نصمم حلولاً متكيفة مع كل احتياج.",
        "features": ["محطات شحن سريع (حتى 150 كيلوواط)", "تغذية شمسية مع تخزين وسيط", "إدارة التدفقات وتحسين التعرفة", "مراقبة الاستهلاك والجلسات", "التوافق مع جميع معايير الشحن"],
        "useCases": ["مواقف الشركات", "محطات الخدمة", "المراكز التجارية", "المساكن الجماعية"]
      },
      {
        "title": "حلول سكنية",
        "shortDesc": "أنظمة شمسية للمنازل والفنادق والمرافق الصحية.",
        "fullDesc": "تجمع حلولنا السكنية بين الأداء والجمالية والبساطة. كل تركيب مصمم حسب الطلب، محجّم وفقًا لاستهلاك المنزل وقيود الموقع. تركيب جاهز للتسليم مع صيانة مشمولة.",
        "features": ["تركيب جاهز للتسليم في 2 إلى 5 أيام", "صيانة وقائية وتصحيحية مشمولة", "ضمان ممتد على المعدات والعمالة", "مراقبة عن بعد للإنتاج", "استهلاك ذاتي وبيع الفائض"],
        "useCases": ["المنازل الفردية", "الفنادق وبيوت الضيافة", "العيادات والصيدليات", "المدارس ومراكز التدريب"]
      },
      {
        "title": "حلول صناعية",
        "shortDesc": "أنظمة عالية القدرة للمناطق الريفية وعمليات التعدين والصناعات.",
        "fullDesc": "للاحتياجات الطاقوية الأكثر تطلبًا، ننشر أنظمة صناعية عالية القدرة. من المناجم المعزولة إلى المناطق الصناعية، تضمن حلولنا طاقة موثوقة على مدار الساعة مع عائد استثمار محسن.",
        "features": ["قدرات من 100 كيلوواط إلى عدة ميغاواط", "متانة صناعية معتمدة", "دعم فني على مدار الساعة مع خط ساخن مخصص", "إمكانية الدمج الهجين ديزل/شمسي", "إشراف مركزي متعدد المواقع"],
        "useCases": ["المناجم والمحاجر", "المناطق الصناعية", "مصانع التصنيع", "الموانئ والمطارات"]
      },
      {
        "title": "أبراج وهوائيات الاتصالات",
        "shortDesc": "تركيب وصيانة أبراج الاتصالات والصواري ذاتية الدعم والمشدودة بالأسلاك.",
        "fullDesc": "IS TELECOM هي جهة فاعلة رئيسية في نشر البنية التحتية للاتصالات في أفريقيا. نقوم بتصميم وتصنيع وتركيب أبراج الاتصالات بجميع الأحجام: الأبراج ذاتية الدعم، والصواري المثبتة بالأسلاك، والأحادية القطب، والصواري الأنبوبية. تعمل فرقنا على جميع أنواع التضاريس، من المراكز الحضرية الكثيفة إلى المناطق الريفية الأكثر عزلة.",
        "features": ["أبراج ذاتية الدعم حتى 120 مترًا", "أبراج مثبتة بالأسلاك للمناطق ذات الرياح العالية", "أحادية قطب حضرية مدمجة", "الأساسات والهندسة المدنية مشمولة", "المعايير الدولية (ANSI/TIA-222)"],
        "useCases": ["مشغلو الهاتف المحمول (MTN، Orange، Vodacom)", "الوصلات الميكروية", "البث الإذاعي والتلفزيوني", "الطاقة (الرياح، المراقبة)"]
      },
      {
        "title": "شبكات الألياف البصرية",
        "shortDesc": "نشر شبكات الألياف البصرية وشبكات النقل الأساسية لمشغلي الاتصالات.",
        "fullDesc": "نقوم بنشر شبكات الألياف البصرية من البداية إلى النهاية: دراسات هندسية، مد الكابلات، التوصيل، اختبارات الأداء والتشغيل. تتقن فرقنا تقنيات GPON وFTTH والشبكات الأساسية طويلة المدى. شركاء مرجعيون لكبرى شركات الاتصالات الأفريقية.",
        "features": ["نشر FTTH (الألياف إلى المنزل)", "الشبكات الأساسية طويلة المدى بين المدن", "التوصيل بالصهر واختبارات OTDR", "دراسات هندسية وتصاميم أولية مفصلة", "صيانة وإصلاح الكابلات التالفة"],
        "useCases": ["الشبكات الحضرية", "ربط المواقع المعزولة", "مراكز البيانات ومحاور الاتصالات", "الحرم الجامعي والمناطق الصناعية"]
      },
      {
        "title": "صيانة وخدمات الاتصالات",
        "shortDesc": "صيانة وقائية وتصحيحية ودعم فني على مدار الساعة لبنيتك التحتية للاتصالات.",
        "fullDesc": "تعتمد موثوقية شبكتك على الصيانة الدقيقة. تقدم IS TELECOM عقود صيانة مخصصة لبنيتك التحتية للاتصالات: تدخلات وقائية مجدولة، استكشاف الأخطاء التصحيحية السريعة، دعم فني على مدار الساعة وإدارة قطع الغيار. فرقنا مدربة ومعتمدة من قبل أكبر مصنعي المعدات.",
        "features": ["صيانة وقائية مع تخطيط مخصص", "تدخل تصحيحي في غضون 4 ساعات (SLA مضمون)", "دعم فني NOC على مدار الساعة", "إدارة قطع الغيار والمخزون الاحتياطي", "تقارير أداء شهرية (KPIs)"],
        "useCases": ["مواقع الاتصالات قيد التشغيل", "مراكز البيانات", "محطات الراديو الأساسية", "مراكز التحويل"]
      }
    ]
  },
  "notFound": {
    "title": "الصفحة غير موجودة",
    "description": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
    "backHome": "العودة إلى الرئيسية"
  },
  "langSelector": {
    "fr": "Français",
    "en": "English",
    "es": "Español",
    "zh": "中文",
    "ar": "العربية"
  }
};